import { omitIsNil } from '@src/utils/omit';
import api from './api';

export const getRewardTransactions = async ({ offset, limit, sort }) => {
  try {
    const params = omitIsNil({
      offset,
      limit,
      sort,
    });

    const response = await api({
      method: 'GET',
      url: '/reward-transactions',
      params,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};
